var overArg = require('./_overArg');

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/lodash/_nativeKeys.js
// module id = 815
// module chunks = 0 1 2 3 4 5 6 7 8